import { useState } from 'react';
import { MenuItem } from '@szhsin/react-menu';
import { useTranslation } from 'react-i18next';
import './Notifications.css';

const PREVIEW_LIMIT = 90;

const getPreviewText = (text) => {
  const normalized = String(text || '').trim();
  if (normalized.length <= PREVIEW_LIMIT) return normalized;
  return `${normalized.slice(0, PREVIEW_LIMIT).trim()}…`;
};

function NotificationItem({ option, onSelect, onOpenMessage }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const fullText = String(
    option.fullMessage || option.subtitle || option.title || '',
  ).trim();
  const isLong = fullText.length > PREVIEW_LIMIT;
  const preview = getPreviewText(fullText);

  return (
    <MenuItem
      key={option.id}
      disabled={Boolean(option.disabled)}
      className={`not-menu-item ${option.read ? 'is-read' : 'is-unread'}`}
      onClick={(e) => {
        e.keepOpen = !option.hasDetails;
        onSelect?.(option);
      }}
    >
      <div className="not-card">
        <div className="not-card-top">
          <div className="not-card-icon">
            <i className={option.icon || 'fas fa-bell'} />
          </div>
          <div className="not-card-body">
            <div className="not-card-row">
              <span className="not-card-title">{option.title}</span>
              <span className="not-card-time">{option.time}</span>
            </div>
            {fullText && (
              <p className="not-card-message">
                {expanded || !isLong ? fullText : preview}
              </p>
            )}
            <div className="not-card-actions">
              {isLong && (
                <button
                  type="button"
                  className="not-card-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.keepOpen = true;
                    const nextExpanded = !expanded;
                    setExpanded(nextExpanded);
                    if (nextExpanded) {
                      onOpenMessage?.(option);
                    }
                  }}
                >
                  {expanded
                    ? t('notifications.showLess')
                    : t('notifications.readMore')}
                </button>
              )}
              {/* Otvaranje taba privremeno isključeno — samo pročitaj
              {option.hasDetails && (
                <button
                  type="button"
                  className="not-card-btn not-card-btn-secondary"
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpenDetails?.(option);
                  }}
                >
                  {t('notifications.openDetails')}
                </button>
              )}
              */}
            </div>
          </div>
          {!option.read && <span className="not-card-dot" />}
        </div>
      </div>
    </MenuItem>
  );
}

export default NotificationItem;
